function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAiCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-b26357c8-7eeb-46d7-86fb-19bcaacdf3d1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m15.071,20.866c-.267,0-.526-.107-.716-.302-.017-.018-1.708-1.752-2.567-2.523-.411-.369-.446-1.001-.077-1.412.369-.411,1.001-.445,1.412-.076.454.407,1.101,1.042,1.644,1.584.829-1.729,2.388-4.743,4.017-6.651.359-.42.99-.47,1.41-.111.42.359.47.99.111,1.41-2.146,2.515-4.296,7.431-4.317,7.48-.133.306-.409.525-.737.585-.06.011-.12.017-.18.017Z",
    style: {
      fill: "#e7e7e7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16,26.708c-5.905,0-10.708-4.804-10.708-10.708s4.804-10.708,10.708-10.708,10.708,4.804,10.708,10.708-4.804,10.708-10.708,10.708Zm0-19.417c-4.802,0-8.708,3.907-8.708,8.708s3.906,8.708,8.708,8.708,8.708-3.907,8.708-8.708-3.906-8.708-8.708-8.708Z",
    style: {
      fill: "#e7e7e7"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiCheck);
export default __webpack_public_path__ + "static/media/AICheck.e438a3588b2a7598249e86d9601f646a.svg";
export { ForwardRef as ReactComponent };